import { ECode } from '~/constants';
import Intl from '@fx-ui/intl';
import { Alert, Message } from '@fx-ui/fine-design';
import { get, getErrorMsg, getUUID, isUndefined, post } from '~/utils';
import { socket } from '../socket';

/**
 * 触发Excel导出
 *
 * @param url
 * @param data
 * @param onSuccess
 * @param limit
 */
export const invokeExcelExport = (
    url: string,
    data?: any,
    onSuccess?: (taskId: string) => void,
    limit = 5
) => {
    const taskId = getUUID();
    return post(
        url,
        {
            ...data,
            taskId
        },
        {
            customHandleHttpCodes: [400],
            customHandleErrorCodes: [
                ECode.RPC_TOO_MANY_REQUESTS,
                8303,
                ECode.INTEGRATE_API_FREQUENCY_MAX_EXCEEDED
            ]
        }
    )
        .then(() => {
            socket.setExcelExport(taskId, onSuccess);
        })
        .catch((error) => {
            const resData = get(error, 'response.data');
            const errorCode = get(resData, 'code');
            const httpCode = get(error, 'response.status');
            // API调用次数上限
            if (
                [
                    ECode.RPC_TOO_MANY_REQUESTS,
                    ECode.INTEGRATE_API_FREQUENCY_MAX_EXCEEDED,
                    8303
                ].includes(errorCode)
            ) {
                Alert.openAlert({
                    type: 'warning',
                    message: Intl.get('contact.export.api.max.message', { limit }),
                    title: Intl.get('contact.export.api.max.title'),
                    text4Ok: Intl.get('iSee'),
                    text4Cancel: null
                });
                return;
            }
            if (!isUndefined(errorCode) && httpCode === 400) {
                Message.warning(getErrorMsg(resData) || Intl.get('export.failTip'));
            }
            return Promise.reject(error);
        });
};
